import { Grid } from '@mui/material'
import { ExternalUser } from '../../../../generated'
import FinalBills from '../../../pages/main/billing/FinalBills'

interface ClientDetailCardProps {
  client?: ExternalUser | null
}

const ClientInvoicesCard = ({ client }: ClientDetailCardProps) => {
  return (
    <Grid container spacing={5}>
      <Grid item md={12} lg={12} sm={12} xs={12} gap={3}>
        <FinalBills />
      </Grid>
    </Grid>
  )
}

export default ClientInvoicesCard
